<template>
  <div class="main-content">
    <div class="modal" tabindex="-1" role="dialog" id="cancelUserSentModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="cancelUserSent.id">
          <div class="modal-header">
            <h5 class="modal-title">
              Cancelar envio de {{ cancelUserSent.user.name }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Motivo:</label>
                  <textarea
                    class="form-control"
                    rows="4"
                    v-model="cancelReason"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              @click="cancel(cancelUserSent)"
              class="btn btn-danger"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Nome do Lote</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <span style="font-size: 21px; font-weight: bold; color: #000">{{
                  batches.name
                }}</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-md-6">
                Documento:
                {{
                  batches.signature_document
                    ? batches.signature_document.name
                    : "Lote de Documentos Avulsos"
                }}
              </div>
              <div class="col-md-3 text-right">
                <span v-if="batches.sent_date"
                  >Data de primeiro envio:
                  {{ formatDateTime(batches.sent_date) }}</span
                >
              </div>
              <div class="col-md-3 text-right">
                Data limite para assinatura: {{ format(batches.limit_date) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Widgets -->
    <div class="row justify-content-md-center">
      <div class="col-lg-3 col-md-6">
        <div class="card pastel-green">
          <div class="card-body position-relative overflow-hidden">
            <i class="fas fa-clipboard-list card-img"></i>
            <div class="card-value">
              <div class="number">{{ batches.total_sents }}</div>
              <div class="text">Assinaturas Solicitadas</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card pastel-yellow">
          <div class="card-body position-relative overflow-hidden">
            <i class="fas fa-user-tie card-img"></i>
            <div class="card-value">
              <div class="number">{{ batches.pending }}</div>
              <div class="text">Assinaturas Pendentes</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card pastel-blue">
          <div class="card-body position-relative overflow-hidden">
            <i class="fas fa-users card-img"></i>
            <div class="card-value">
              <div class="number">{{ batches.completed }}</div>
              <div class="text">Assinaturas Concluídas</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card pastel-red">
          <div class="card-body position-relative overflow-hidden">
            <i class="fas fa-percent card-img"></i>
            <div class="card-value">
              <div class="number">{{ batches.late }}</div>
              <div class="text">Assinaturas Atrasadas</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Seleção de Assinantes</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-hover data-table">
                    <thead>
                      <tr>
                        <th scope="col">ID Assinatura</th>
                        <th scope="col">Nome Assinante</th>
                        <th scope="col">Matrícula</th>
                        <th scope="col">Documento</th>
                        <th scope="col">Empresa</th>
                        <th scope="col">Unidade</th>
                        <th scope="col">Data do Envio</th>
                        <th scope="col">Data de Assinatura</th>
                        <th scope="col">Status</th>
                        <th scope="col">Views</th>
                        <th scope="col">Contagem de Reenvios</th>
                        <th scope="col">Ação</th>
                      </tr>
                      <tr>
                        <th class="th-slim">
                          <input @change="getBatches()" v-model="filters.id" class="form-control" placeholder="Filtrar por ID">
                        </th>
                        <th class="th-slim">
                        </th>
                        <th class="th-slim">
                          <input @change="getBatches()" class="form-control" v-model="filters.register" placeholder="Filtrar por Matrícula">
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(user_sent, userIndex) in batches.users_sent.data"
                        :key="user_sent.id"
                      >
                        <td>{{ user_sent.id }}</td>
                        <td>{{ user_sent.user.name }}</td>
                        <td>{{ user_sent.user.register }}</td>
                        <td>
                          {{
                            user_sent.detached == 1
                              ? user_sent.document_name
                              : batches.signature_document.name
                          }}
                        </td>
                        <td>{{ user_sent.user.company.fantasy_name }}</td>
                        <td>{{ user_sent.user.sector.name }}</td>
                        <td>{{ batches.sent_at }}</td>
                        <td>
                          {{
                            user_sent.signed == 0
                              ? "Não Assinado"
                              : user_sent.signed_at
                          }}
                        </td>
                        <td>
                          <span
                            class="badge"
                            :class="[
                              user_sent.status == 'done'
                                ? 'pastel-green'
                                : user_sent.status == 'pending'
                                ? 'pastel-yellow'
                                : 'pastel-red',
                            ]"
                            >{{
                              user_sent.status == "done"
                                ? "Concluído"
                                : user_sent.status == "pending"
                                ? "Pendente"
                                : user_sent.status == "late"
                                ? "Atrasado"
                                : "Cancelado"
                            }}</span
                          >
                        </td>
                        <td>{{ user_sent.view_counter }}</td>
                        <td>{{ user_sent.resend_counter }}</td>
                        <td>
                          <button
                            @click="iframe(user_sent.document_http)"
                            class="btn btn-crud view"
                            data-tooltip="tooltip"
                            title="Visualizar"
                            v-if="!multiple"
                          >
                            <i class="far fa-eye"></i>
                          </button>

                          <button
                            v-if="user_sent.isNextPerson || !multiple"
                            @click="reSend(user_sent)"
                            class="btn btn-crud yellow"
                            data-tooltip="tooltip"
                            title="Reenviar"
                          >
                            <i class="far fa-envelope"></i>
                          </button>
                          <button
                            v-if="!user_sent.canceled_at && (!multiple || user_sent.isNextPerson)"
                            @click="cancelModal(user_sent)"
                            class="btn btn-crud delete"
                            data-tooltip="tooltip"
                            title="Cancelar"
                          >
                            <i class="fas fa-ban"></i>
                          </button>
                          <button
                            v-if="multiple && user_sent.signed == 1"
                            @click="det(user_sent, userIndex)"
                            class="btn btn-crud blue"
                            data-tooltip="tooltip"
                            title="Localização"
                          >
                            <i class="fas fa-map-marker-alt"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                    <pagination :records="batches.users_sent.total" :options="options" :per-page="10" @paginate="getBatches">
                    </pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Documento -->

    <div
      class="modal fade"
      id="modalDocument"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Visualização do Documento
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div>
            <iframe :src="document_http" class="iframe"></iframe>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detalhe Assinatura -->

    <div
      class="modal fade"
      id="modalDetail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div v-if="detail.user" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Detalhes da Assinatura</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="row content-detail">
            <div class="col-md-6" style="font-size: 16px;">
              <i class="fas fa-user"></i>
              &nbsp;Assinado por {{ detail.user.name }}
            </div>

            <div class="col-md-6" style="font-size: 16px">
              <i class="fas fa-calendar-check"></i>
              &nbsp;Assinado em {{ detail.signed_at }}
            </div>
          </div>
          <div class="row content-detail">
            <div class="col-md-6" style="font-size: 16px;">
              <i class="fas fa-globe-americas"></i>
              &nbsp;Assinado no IP {{ batches.users_sent.data[0].users_signed[userIndex].ip}}
            </div>
          </div>
          <div class="row content-detail">
            <div class="col-md-12" style="font-size: 16px">
              <i class="fas fa-map-marked-alt"></i>
              &nbsp;Geolocalização (Latitude: {{ detail.latitude }} | Longitude: {{ detail.longitude }})
            </div>
          </div>
          <div class="row content-detail">
            <div class="col-md-12">
              <iframe
                width="100%"
                height="250"
                frameborder="0"
                style="border:0"
                :src="src"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
export default {
  data() {
    return {
      filters: {
        id: "",
        register: "",
      },
      page: 1,
      multiple: false,
      src: "",
      userIndex: "",
      detail: [],
      batches: [],
      document_http: "",
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
      },
      cancelReason: "",
      cancelUserSent: "",
      total: 0,
    };
  },
  methods: {
    det(det, index) {
      this.userIndex = index;
      this.detail = det;
      this.src =
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyAVReyDOd0JcVSHy1CvERGbMXbqA1pkiZA&q=" +
        this.detail.latitude +
        "," +
        this.detail.longitude +
        "&zoom=18&maptype=roadmap";
      $("#modalDetail").modal();    
    },
    cancelModal(userSent) {
      this.cancelUserSent = userSent;
      $("#cancelUserSentModal").modal("show");
    },
    cancel(userSent) {
      if(this.cancelReason == ""){
        this.$message("Erro", "Digite o motivo do cancelamento", "error");
        return
      }
      $("#page_loader").show();
      const self = this;
      const api =
        self.$store.state.api + "signatureusersents/cancel/" + userSent.id;
      const fd = new FormData();
      fd.append("cancel_reason", self.cancelReason);
      self.$http
        .post(api, fd)
        .then((response) => {
          self.getBatches();
          $("#cancelUserSentModal").modal("hide");
          self.$message("Sucesso", "Envio cancelado com sucesso", "success");
          $("#page_loader").hide();
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          $("#page_loader").hide();
        });
    },
    reSend(signatureUserSent) {
      const self = this;
      const api =
        self.$store.state.api +
        "signatureusersents/resend/" +
        signatureUserSent.id;
      self.$http
        .get(api)
        .then((response) => {
          self.getBatches();
          self.$message("Sucesso", "Reenviado com sucesso", "success");
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    format(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatDateTime(dateTime) {
      return moment(dateTime).format("DD/MM/YYYY HH:mm:ss");
    },
    iframe(url) {
      this.document_http = url;
      $("#modalDocument").modal();
    },
    getBatches: async function (page = null) {
      const self = this;
      const api =
        self.$store.state.api +
        "signaturebatches/paginatedView/" +
        self.$route.params.id + "/?page=" + (page ? page : 1);
      await self.$http
        .post(api, {
          filters: self.filters
          })
        .then((response) => {
          self.batches = response.data;
          if(self.batches.is_multiple == 1){
            this.multiple = true;
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    doStuff: async function (job_status_id) {
      if (!job_status_id) return;

      const self = this;

      const tokens = [];

      const interval = setInterval(() => {
        const cancelTokenSource = self.$http.CancelToken.source();

        tokens.push(cancelTokenSource);

        self.$http
          .get(`${self.$store.state.api}jobStatus/${job_status_id}`, {
            cancelToken: cancelTokenSource.token,
          })
          .then((res) => {
            if (!res) return;

            const jobStatus = res.data;
            console.debug(
              `${jobStatus.progress_now} de ${jobStatus.progress_max}`
            );

            self.$store.commit("setShowProgress", true);
            self.$store.commit("setMaxProgressValue", jobStatus.progress_max);
            self.$store.commit("setProgressValue", jobStatus.progress_now);

            if (jobStatus.status === "finished") {
              tokens.forEach((token) => {
                token.cancel();
              });

              console.debug(`Job finalizado em ${jobStatus.finished_at}`);
              clearInterval(interval);

              $("#page_loader").hide();
              self.$store.commit("setShowProgress", false);
            }
          })
          .catch((error) => {
            console.error(error);

            // self.$message("Erro", error, "error");
            $("#page_loader").hide();
            self.$store.commit("setShowProgress", false);

            clearInterval(interval);
          });
      }, 5000);
    },
  },
  mounted() {
    const self = this;

    this.getBatches();
    this.doStuff(self.$route.query.job_status_id);
  },
  components: { Pagination },
};
</script>
<style scoped>
.th-slim {
  border-bottom: 1px;
}
.iframe {
  width: 100%;
  height: 700px;
}
.content-detail {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SignatureBatch/View.vue